import { SendChatMessageInput } from "@/domain/dtos/inputs";
import { Chat } from "@/domain/entities";
import { NotFoundError } from "@/domain/errors";
import { ChatMapper } from "@/domain/mappers";
import { ChatRepository } from "@/domain/repositories";
import { ChatDataSource } from "../datasources/chat";
import { ChatMessageResponse, ChatResponse } from "../dtos/responses";

export class ChatRepoImpl implements ChatRepository {
  constructor(
    private readonly dataSource: ChatDataSource,
    private readonly chatMapper: ChatMapper<ChatResponse, ChatMessageResponse>,
  ) {}

  async getChats(): Promise<Chat[]> {
    const data = await this.dataSource.getChats();

    if (!data) {
      return [];
    }

    const chats = data
      .map((elem) => this.chatMapper.toDomain(elem))
      .sort((a: Chat, b: Chat) => {
        if (a.last_message_date_timestamp > b.last_message_date_timestamp) {
          return -1;
        }
        if (a.last_message_date_timestamp < b.last_message_date_timestamp) {
          return 1;
        }
        return 0;
      });

    return chats;
  }

  async getChatById(id: number) {
    const data = await this.dataSource.getChatById(id);
    return this.chatMapper.toDomain(data);
  }

  async sendMessage(params: SendChatMessageInput) {
    const data = await this.dataSource.sendMessage(params);
    return this.chatMapper.toMessageDomain(data);
  }

  async getMessages(chatId: number) {
    const data = await this.dataSource.getMessages(chatId);

    if (!data) {
      throw new NotFoundError("Mensagens");
    }

    return data.map((elem) => this.chatMapper.toMessageDomain(elem));
  }

  async editMessage(id: number | string, message: string) {
    const data = await this.dataSource.editMessage(id, message);
    return this.chatMapper.toMessageDomain(data);
  }

  async pinChat(chatId: number) {
    await this.dataSource.pinChat(chatId);
  }

  async archiveChat(chatId: number) {
    await this.dataSource.archiveChat(chatId);
  }
}
